'use client';
import React, { useCallback, useEffect, useState } from 'react';
import styled from '@benzinga/themetron';
import { Button } from '@benzinga/core-ui';
import { Watchlist } from '@benzinga/watchlist-manager';
import { useTranslation } from 'react-i18next';
import { WatchlistSelect } from '../WatchlistSelect';
import { Movers, MoversBlank } from '@benzinga/ui';

export interface WatchListMoversProps {
  isLoadingWatchlists?: boolean;
  watchlists?: Watchlist[];
}

const allWatchlistTickers = (watchlists: Watchlist[]) => {
  const tickers: string[] = [];
  watchlists.forEach(portfolio => {
    portfolio.symbols.forEach(item => {
      if (!tickers.includes(item.symbol)) {
        tickers.push(item.symbol);
      }
    });
  });
  return tickers;
};

const getWatchlistTickers = (watchlist: Watchlist) => {
  const tickers: string[] = [];
  watchlist.symbols.forEach(item => {
    tickers.push(item.symbol);
  });
  return tickers;
};

export const WatchListMovers = ({ isLoadingWatchlists, watchlists }: WatchListMoversProps) => {
  const [symbols, setSymbols] = useState<string[] | null>(null);
  const [watchlist, setWatchlist] = useState<Watchlist | null>(null);
  const [, setHasManyTickers] = useState<boolean>(false);
  const { t } = useTranslation('common');

  const handleSelectedWatchlist = useCallback(
    (watchlist: Watchlist) => {
      setWatchlist(watchlist);
    },
    [setWatchlist],
  );

  // Update Symbols
  useEffect(() => {
    if (watchlist) {
      const tickers = getWatchlistTickers(watchlist);
      setSymbols(tickers);
    } else if (watchlists) {
      const tickers: string[] = allWatchlistTickers(watchlists);
      // console.log('ticker count: ', tickers.length);
      const watchlistId = localStorage.getItem('SELECTED_WATCHLIST');
      const w: Watchlist | undefined = watchlists?.filter(watchlist => {
        return watchlist.watchlistId == watchlistId;
      })[0];
      if (tickers.length > 50) {
        setHasManyTickers(true);
        setWatchlist(w ? w : watchlists[0]);
      } else if (w) {
        setWatchlist(w);
      } else {
        setSymbols(tickers);
      }
    }
  }, [setHasManyTickers, setSymbols, setWatchlist, watchlist, watchlists]);

  return (
    <WatchlistMoversWrapper className="movers">
      {watchlists?.length === 1 ? null : (
        <WatchlistSelect onSelect={handleSelectedWatchlist} watchlist={watchlist} watchlists={watchlists} />
      )}
      {isLoadingWatchlists ? (
        <MoversBlank />
      ) : (
        <Movers cellDataAction="Your Watchlist Movers Quote Cell Click" symbols={symbols} />
      )}
      <div className="movers-footer">
        <a
          data-action="Customize Watchlist Click"
          href="https://www.benzinga.com/profile/portfolio/?utm_source=watchlist-movers"
        >
          <Button className="justify-center w-full">{t('Sidebars.Widgets.WatchListMovers.button')}</Button>
        </a>
      </div>
    </WatchlistMoversWrapper>
  );
};

export const WatchlistMoversWrapper = styled.div`
  &.movers {
    display: flex;
    flex-direction: column;
    .movers-footer {
      margin-top: 8px;
      button {
        width: 100%;
        justify-content: center;
      }
    }
  }
`;

export default WatchListMovers;
